<template lang="pug">
.content-wrap
  .content-top
    .con
      .reset-wrapper.reg-pg
        //- img(src='/new/img/reg-banner.jpg')
        a.d-block(href="javascript:void(0)" @click="toEx()")
          img(src='/new/img/new.jpg')
        //- img(:src="$helpers.timingControl('2024-08-28 13:00', 'login-banner', 'rg')")
        .modal-header-cus
          h2 {{$t('ui.register')}}
        form
          template(v-if="step == 1")
            .mb-2
              input.form-control#signUpUsername(type='text' autocomplete="off" v-model.trim="$v.signUpUsername.$model" :placeholder="$t('ui.phone_number')" @keyup.enter="signUp" minLength="9" maxlength="11" @keypress="$helpers.onlyNumber")
            validation.mb-2(:value="$v.signUpUsername" :name="$t('ui.phone_number')" target="REGISTERNO")
            .mb-2
              input.form-control(type='password' autocomplete="off" v-model.trim="$v.signUpPassword.$model" @keyup.enter="signUp" :placeholder="$t('ui.password')" maxlength="20")
            validation.mb-2(:value="$v.signUpPassword" :name="$t('ui.password')" target="REGISTERPW")
            //- .input-group.flex-nowrap
              //- span.input-group-text.btns.s2#addon-wrapping +63
              input.form-control(type='text' :placeholder="$t('ui.phone_number')" minLength="10" maxlength="10" v-model.trim="$v.registerNo.$model" @keypress="$helpers.onlyNumber" @keyup.enter="signUp")
            //- .mb-2.d-flex.justify-content-between
              .btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center.prefix +63
              input.form-control(type='text' :placeholder="$t('ui.phone_number')" minLength="10" maxlength="10" v-model.trim="$v.registerNo.$model" @keypress="$helpers.onlyNumber" @keyup.enter="signUp")
            //- validation.mb-2(:value="$v.registerNo" :name="$t('ui.phone_number')" target="REGISTERNO")
            //- .mb-2
              input.form-control(type='password' :placeholder="$t('ui.confirm_password')")
            //- .mb-2
              input.form-control(type='text' :placeholder="$t('ui.email')+'('+$t('ui.optional')+')'" v-model.trim="$v.userEmail.$model"  @keyup.enter="signUp")
            //- validation.mb-2(:value="$v.userEmail" :name="$t('ui.email')" target="REGISTEREMAIL")
            .mb-2 
              input.form-control(type='text' :placeholder="$t('ui.referral_code')+'('+$t('ui.optional')+')'" v-model="referralCode" @keypress="$helpers.onlyAlphaNum" @keyup.enter="signUp" :disabled="disabledRef")
            .s2.position-relative
              //- .position-absolute.partner-icon.pointer(v-if="$helpers.timingFilter('2025-11-01 00:00')")
                a(href="https://epicwincuci.com/RF11563559" target="_blank")
                  img(src="/new/img/link.png")
              .text-center
                button.btn-submit(type="button" @click.stop="signUp") {{$t('ui.register')}}
              .text-center.mt-4
                router-link.modal-link(to="/login") {{$t('ui.signupform.account_exist')}} 
                  b {{$t('ui.login_now')}}
              .text-center.mt-3
                router-link.modal-link(to="/") 
                  b.text-uppercase {{$t('ui.home')}}
          template(v-if="step == 2")
            .verification.p-3.mb-1
              .text-capitalize.text-center.mb-3.text-verify {{ $t("ui.verification_number") }}
              .text-center.mb-2(v-if="tacCountDown") {{ $t("message.tac_tooltips") }}
              .input-group.flex-nowrap
                input.form-control.text-center(type='text' autocomplete="off" :placeholder="$t('ui.tac_code')"  v-model.trim="$v.tacCode.$model" @keypress="$helpers.onlyNumber")
                .input-group-text.btns.s2.disabled-grey(v-if="tacCountDown") {{ tacDisplay }}
                .input-group-text.btns.s2.pointer(v-else @click="resendTacCode") {{ $t("ui.resend") }}
              //- .d-flex.justify-content-between.px-1
                .input-group
                  input.form-control.text-center(type='text' autocomplete="off" :placeholder="$t('ui.tac_code')"  v-model.trim="$v.tacCode.$model" @keypress="$helpers.onlyNumber")
                  .btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center.disabled-grey(v-if="tacCountDown")
                    | {{ tacDisplay }}
                  .btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center(v-else @click="resendTacCode")
                    | {{ $t("ui.resend") }}
            .modal-footer.s2
              .text-center
                button.btn-submit.text-capitalize(type="button" @click.stop="tacValidate") {{$t('ui.next')}}
            //- a(href="javascript:void(0);" @click.stop="tacValidate" :disabled="loading")
            //-   .btn.btn-block.btn-main.btn-purple  {{ $t("ui.next") }}
            .font-weight-bold.text-danger.mt-3.p-2 {{$tc('ui.tac_tips')}}
            div.modal-livechat-btn.livechat_button.text-center.mb-2
              img.pointer(src="/new/img/livechat.png" @click="openChat")
          partnerGif
      footerInfo
  //- #regModal2.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-dialog-centered
      .modal-content
        img(src='/new/img/daily.gif')
        //- img(:src="$helpers.timingControl('2024-08-28 13:00', 'login-banner', 'rg')")
        .modal-header-cus
          //- img(src='/new/img/logo.png')
          h2 {{$t('ui.register')}}
        form
          .verification.p-3.mb-1
            .text-capitalize.text-center.mb-3.text-verify {{ $t("ui.verification_number") }}
            .text-center.mb-2(v-if="tacCountDown") {{ $t("message.tac_tooltips") }}
            .input-group.flex-nowrap
              input.form-control.text-center(type='text' autocomplete="off" :placeholder="$t('ui.tac_code')"  v-model.trim="$v.tacCode.$model" @keypress="$helpers.onlyNumber")
              .input-group-text.btns.s2.disabled-grey(v-if="tacCountDown") {{ tacDisplay }}
              .input-group-text.btns.s2.pointer(v-else @click="resendTacCode") {{ $t("ui.resend") }}
            //- .d-flex.justify-content-between.px-1
              .input-group
                input.form-control.text-center(type='text' autocomplete="off" :placeholder="$t('ui.tac_code')"  v-model.trim="$v.tacCode.$model" @keypress="$helpers.onlyNumber")
                .btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center.disabled-grey(v-if="tacCountDown")
                  | {{ tacDisplay }}
                .btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center(v-else @click="resendTacCode")
                  | {{ $t("ui.resend") }}
          .modal-footer.s2
            .text-center
              button.btn-submit.text-capitalize(type="button" @click.stop="tacValidate") {{$t('ui.next')}}
          //- a(href="javascript:void(0);" @click.stop="tacValidate" :disabled="loading")
          //-   .btn.btn-block.btn-main.btn-purple  {{ $t("ui.next") }}
        .font-weight-bold.text-danger.mt-3.p-2 {{$tc('ui.tac_tips')}}
        div.modal-livechat-btn.livechat_button.text-center.mb-2(@click="openChat")
          img(src="/new/img/livechat.png")
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
  email
} from "vuelidate/lib/validators";
import validation from "@/library/_validation.vue";
import _ from "lodash";
import partnerGif from "@/component/_partnerGif.vue"
import footerInfo from '@/views/default/_footerArticle.vue'
export default {
  components: {
    validation,
    partnerGif,
    footerInfo
  },
  data() {
    return {
      signUpUsername: "",
      signUpPassword: "",
      // registerNo: "",
      referralCode: "",
      affiliateCode: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      conditionChecked: false,
      isTacPanel: false,
      tacCode: "",
      disabledRef: false,
      disabledAffi: false,
      tacTimer: null,
      tacCountDown: false,
      tacDisplay: "",
      ch: "",
      cm: "",
      pp: "",
      userEmail: "",
      // postBack: false,
      // postId: "",
      // postPayout: "",
      // aid: "",
      // pid:"",
      // tid:"",
      step: 1,
      fbp: null
      // emailChecked: false,
    };
  },
  computed: {
    getAnnAfterLog() {
      return this.$store.state.user.annAfterLog;
    },
    getLanguage() {
      return this.$store.getters.language || "en";
    }
  },
  validations: {
    signUpUsername: {
      required,
      numeric,
      minLength: minLength(9),
      maxLength: maxLength(11)
      // valid: function(value) {
      //   const containsAlphabet = /[A-Za-z]/.test(value);
      //   const containsNumber = /[0-9]/.test(value);
      //   return containsAlphabet || containsNumber;
      // }
    },
    signUpPassword: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20),
      // valid: function(value) {
      //   const containsAlphabet = /[A-Za-z]/.test(value);
      //   const containsNumber = /[0-9]/.test(value);
      //   return containsAlphabet && containsNumber;
      // }
    },
    // registerNo: {
    //   required,
    //   numeric,
    //   minLength: minLength(10),
    //   maxLength: maxLength(10)
    // },
    // userEmail:{
    //   email
    // },
    tacCode: {
      required(val) {
        return this.isTacPanel ? required(val) : true;
      }
    }
  },
  created() {
    // if (!_.isEmpty(this.$route.query)) {
      // if (this.$route.query.visitor_id){
      //   this.postBack = true
      //   this.postId = this.$route.query.visitor_id
      //   this.aid = this.$route.query.aid
      //   this.pid = this.$route.query.pid
      //   this.tid = this.$route.query.tid
      //   // this.postPayout = this.$route.query.payout
      // }
    // }
  },
  mounted() {
    this.getFbp()
    if(this.$store.state?.user?.tempName != "" && this.$store.state?.user?.tempPass != ""){
      this.step = 2
    }
    if (!_.isEmpty(this.$route.query)) {
      if (this.$route.query.ref) {
        let temp = this.$route.query.ref.split("/")
        this.referralCode = temp[0];
        this.disabledRef = true;
      }
      if (this.$route.query.affiliatecode) {
        let temp = this.$route.query.affiliatecode.split("/")
        this.affiliateCode = temp[0];
        this.disabledAffi = true;
      }
      if (this.$route.query.ch) {
        let temp = this.$route.query.ch.split("/")
        this.ch = temp[0];
      }
      if (this.$route.query.cm) {
        let temp = this.$route.query.cm.split("/")
        this.cm = temp[0];
      }
      if (this.$route.query.pp) {
        let temp = this.$route.query.pp.split("/")
        this.pp = temp[0];
      }
      // this.$router.replace('/')
      // if(this.$route.query.promo){

      // }else{
      //   this.$router.push("/register").catch(err => {});
      // }
      
    }
    // $("#regModal").on("shown.bs.modal", function() {
    //   $("#signUpUsername").trigger("focus");
    // });
    // $("#regModal").on("hidden.bs.modal", function() {
    //   $("#signUpUsername").trigger("focus");
    //   this.disabledRef = false;
    //   this.disabledAffi = false;
    // });
  },
  destroyed(){
    this.reset()
  },
  methods: {
    toEx(){
			window.open(
				"https://epicwin100.com/register",
				"_blank",
				"noopener,noreferrer"
			);
		},
    getFbp(){
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${encodeURIComponent('_fbp')}=`);
      if (parts.length === 2) {
        this.fbp = decodeURIComponent(parts.pop().split(';').shift());
      }
    },
    // clickAct(){
    //   $('#regModal').modal('hide')
    //   this.$router.push('/daily-check-in').catch(error =>{})
    // },
    openChat() {
      LiveChatWidget.call("maximize");
    },
    // toggleCheck() {
    //   this.emailChecked = !this.emailChecked;
    //   if (this.emailChecked == false) {
    //     this.userEmail = "";
    //   }
    // },
    countDown() {
      var vm = this;
      var timer = 180000;
      this.tacCountDown = true;
      this.tacTimer = setInterval(() => {
        if (timer > 0) {
          timer -= 1000;
          this.tacDisplay = vm.$moment.utc(timer).format("mm:ss");
        } else {
          this.clearCountDown();
          vm.tacCountDown = false;
          this.tacDisplay = "";
        }
      }, 1000);
    },
    clearCountDown() {
      clearInterval(this.tacTimer);
    },
    getMobile() {
      let isMobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        }
      };

      if (isMobile.iOS()) {
        this.isIOS = true;
      } else {
        this.isIOS = false;
      }
    },
    signUp() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let account_id = this.signUpUsername;
        let password = this.signUpPassword;
        let contact_phone = this.signUpUsername;
        let referral_code = this.referralCode;
        let affiliate_code = this.affiliateCode;
        let contact_email = this.userEmail;
        let ch = this.ch;
        let cm = this.cm;
        let pp = this.pp;
        let fbp = this.fbp
        let domain = window.location.protocol + "//" +window.location.hostname
        // if (localStorage.getItem("fbp") === null) {
        //   var fbp = null;
        // } else {
        //   var fbp = localStorage.getItem("fbp");
        // }
        // if (localStorage.getItem("pixelId") === null) {
        //   var pixelId = null;
        // } else {
        //   var pixelId = localStorage.getItem("pixelId");
        // }
        this.loading = true;
        this.$store
          .dispatch("user/memberSignUp", {
            account_id,
            password,
            contact_phone,
            referral_code,
            affiliate_code,
            ch,
            cm,
            pp,
            fbp,
            domain,
            contact_email
          })
          .then(response => {
            this.loading = false;
            this.feedback.success = response.success;
            this.feedback.status = response.status;
            if (this.feedback.success == true) {
              this.countDown();
              // this.login();
              this.step = 2
            } else {
              // this.isTacPanel = false
              // this.$store.dispatch("user/updatePanel", false);
              this.$helpers.showDialog(
                this.$t("ui.attention"),
                this.$t("message.list." + response.status),
                "info",
                this
              );
              // this.signUpLog(false, this.$t("message.list." + response.status))
            }
          })
          .catch(response => {
            this.loading = false;
            // this.isTacPanel = false
            // this.$store.dispatch("user/updatePanel", false);
            this.feedback.success = false;
            this.$helpers.showDialog(
              this.$t("ui.attention"),
              this.$t("message.list." + response.status),
              "info",
              this
            );
            // this.signUpLog(false, this.$t("message.list." + response.status))
            this.feedback.status = this.$t("error." + response.status);
          });
      }
    },
    tacValidate() {
      this.$v.$touch();
      if (!this.$v.tacCode.$invalid) {
        if (this.$store.state.user.tempName !== "") {
          var account_id = this.$store.state.user.tempName;
        } else {
          var account_id = this.signUpUsername;
        }
        let tac = this.tacCode;
        let referral_code = this.referralCode;
        // let contact_email = this.userEmail;
        this.loading = true;
        this.$store
          .dispatch("user/memberTacValidate", {
            account_id,
            tac,
            referral_code,
            // contact_email
          })
          .then(response => {
            this.loading = false;
            this.feedback.success = response.success;
            this.feedback.status = response.status;
            if (this.feedback.success == true) {
              this.clearCountDown();
              this.login();
              // if(this.postBack == true){
              //   var site = window.location.protocol + "//" + window.location.hostname + "/";
              //   if(this.facebooks.includes(site)){
              //     // this.$http.get("https://evadav.com/phpb?click_id="+this.postId+"&payout="+this.postPayout).then(
              //     this.$http.get("http://ad.propellerads.com/conversion.php?aid="+this.aid+"&pid="+this.pid+"&tid="+this.tid+"&visitor_id="+this.postId).then(
              //       successResponse => {
              //         if(successResponse){
              //           // console.log(successResponse)
              //         }else{
              //           console.log('error')
              //         }
              //       },
              //       errorResponse => {
              //         this.pageLoading = false
              //         console.log(errorResponse)
              //       }
              //     );
              //   }
                
              // }
              // this.reset();
              
            } else {
              if (typeof response.status != "object") {
                this.$helpers.showDialog(
                  this.$t("ui.attention"),
                  this.$t("message.list." + response.status),
                  "info",
                  this
                );
              }
              // this.signUpLog(false, this.$t("message.list." + response.status))
            }
          })
          .catch(response => {
            if (response.status === "tac_expired") {
              this.clearCountDown();
              this.tacCountDown = false;
              this.tacCode = "";
            }
            this.loading = false;
            this.feedback.success = false;
            if (typeof response.status != "object") {
              this.$helpers.showDialog(
                this.$t("ui.attention"),
                this.$t("message.list." + response.status),
                "info",
                this
              );
            }
            this.feedback.status = this.$t("error." + response.status);
            // this.signUpLog(false, this.$t("message.list." + response.status))
          });
      }
    },
    resendTacCode() {
      // this.countDown();
      if (this.$store.state.user.tempName !== "") {
        var account_id = this.$store.state.user.tempName;
      } else {
        var account_id = this.signUpUsername;
      }

      this.loading = true;
      this.$store
        .dispatch("user/memberRenewTac", { account_id })
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success;
          this.feedback.status = response.status;
          if (this.feedback.success == true) {
            this.$helpers.showDialog(
              "success",
              this.$t("ui.tac_code_new"),
              "success",
              this
            );
            this.countDown();
          } else {
            if (typeof response.status != "object") {
              this.$helpers.showDialog(
                this.$t("ui.attention"),
                this.$t("message.list." + response.status),
                "info",
                this
              );
            }
          }
        })
        .catch(response => {
          this.loading = false;
          this.feedback.success = false;
          if (typeof response.status != "object") {
            this.$helpers.showDialog(
              this.$t("ui.attention"),
              this.$t("message.list." + response.status),
              "info",
              this
            );
          }
          this.feedback.status = this.$t("error." + response.status);
        });
    },
    login() {
      if (this.$store.state.user.tempName !== "") {
        var vm = this;
        // if(this.$store.state.user.tempPass === ""){
        //   this.$swal({
        //     title: vm.$tc("ui.attention"),
        //     text: vm.$tc("ui.success"),
        //     type: "success"
        //   }).then(result => {
        //     $('#regModal2').modal('hide')
        //     $('#logModal').modal('show')
        //   });
        //   return
        // }else{
        var username = this.$store.state.user.tempName;
        var password = this.$store.state.user.tempPass;
        var path = "user/login";
        var data = {
          username,
          password
        };
        // }
      } else {
        var username = this.signUpUsername;
        var password = this.signUpPassword;
        var path = "user/login";
        var data = {
          username,
          password
        };
      }

      this.loading = true;
      this.$store
        .dispatch(path, data)
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success;
          if (this.feedback.success == true) {
            this.$store.dispatch("user/tempAccName", "");
            this.$store.dispatch("user/tempPass", "");
            this.$router.push("/").catch(err => {});
            if (this.getAnnAfterLog.length > 0) {
              $("#annModal").modal("show");
            }
          } else {
            var vm = this;
            if (response.status) {
              this.feedback.status = this.$tc(
                "message.list." + response.status
              );
            }
            if (typeof response.status != "object") {
              this.$helpers.showDialog(
                vm.$tc("ui.attention"),
                vm.$tc("message.list." + response.status),
                "info",
                this
              );
            }
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;

          this.feedback.success = response.success;
          var vm = this;
          if (response.status) {
            this.feedback.status = this.$tc("message.list." + response.status);
          }
          if (typeof response.status != "object") {
            this.$helpers.showDialog(
              vm.$tc("ui.attention"),
              vm.$tc("message.list." + response.status),
              "info",
              this
            );
          }
        });
    },
    reset() {
      this.$store.dispatch("user/tempAccName", "");
      this.$store.dispatch("user/tempPass", "");
      // this.clearCountDown();
      // this.tacCountDown = false;
      // this.tacCode = "";
      this.signUpUsername = "";
      this.signUpPassword = "";
      // this.registerNo = "";
      this.$v.$reset();
    }
  }
};
</script>
<style lang="scss" scoped>
.prefix {
  width: 80px;
  cursor: default;
}
.partner-icon{
  top: 0 !important;
  @media (max-width: 767px) {
    top: -10px !important;
  }
}
</style>
    